module.exports = __webpack_public_path__ + "img/Circus18.5a71f8fb.jpg";